// @flow
import React, { PureComponent } from 'react';
import { StyleSheet, View } from 'react-native';
import { Text } from 'trpc-react-native-ui';
import I18n from '../../lib/i18n';

const styles = StyleSheet.create({
  text: {
    fontSize: 14,
  },
});

class BillingAddress extends PureComponent<Props> {
  render = () => (
    <View>
      <Text style={styles.text}>{this.props.street1}</Text>
      {this.props.street2 ? <Text style={styles.text}>{this.props.street2}</Text> : null}
      <Text>
        {I18n.t('addressStreetExcluded', {
          postCode: this.props.postCode,
          city: this.props.city,
        })}
      </Text>
    </View>
  );
}

type Props = StateProps;

export type StateProps = {
  street1: ?string,
  street2: ?string,
  postCode: ?string,
  city: ?string,
};

export default BillingAddress;
